// Generated by genversion.
export const version = '2.61.0';
//# sourceMappingURL=version.js.map